import InfoCards from './InfoCards'

export default InfoCards
